<template>
  <div class="product-flags">
    <span
      v-for="(flag, index) in productFlags"
      :key="index"
      class="product-flags__label | product-label"
      :class="[
        flag ? `product-label--${flag}` : ''
      ]"
    >
      {{ flag }}
    </span>
  </div>
</template>
<script>
  export default {
    props: {
      productFlags: Array
    }
  }

</script>
